import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import { PrivacyPage, TermsPage, DisclaimerPage } from "@/pages/LegalPages";
import NotFoundPage from "@/pages/NotFoundPage";
import { BlogIndexPage, BlogPostPage } from "@/pages/BlogPages";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { setLenis, scrollToId, scrollToTop } from "@/lib/scroll";

const ScrollManager = () => {
    const { pathname, state } = useLocation();
    const section = state?.section;
    useEffect(() => {
        scrollToTop();
        if (!section) return undefined;
        // Arrived from another page to a homepage section: wait for layout, then scroll.
        const t = setTimeout(() => scrollToId(section), 150);
        return () => clearTimeout(t);
    }, [pathname, section]);
    return null;
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
        setLenis(lenis);
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollManager />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/disclaimer" element={<DisclaimerPage />} />
                    <Route path="/blog" element={<BlogIndexPage />} />
                    <Route path="/blog/:slug" element={<BlogPostPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
                <FloatingWhatsApp />
            </BrowserRouter>
        </div>
    );
}

export default App;
